exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".o-key-points{text-align:center!important}.o-key-points__icon .i-retrieve{width:56px;height:56px}@media only screen and (min-width:62.38em){.o-search__item{display:flex!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./client/app/routes/onTheBeach/login/login.less
// module id = 154
// module chunks = 0